"use client";

import React, { useState } from "react";
import { ShieldCheck, Lock, FileCheck, CheckCircle, Loader2 } from "lucide-react";
import { FormProvider, useWvcForm } from "@/integrations/forms/FormProvider";
import { Button } from "@/components/ui/button";
import { Form, FormField, FormItem, FormLabel, FormControl, FormMessage } from "@/components/ui/form";
import { useRevealOnScroll } from "@/hooks/useRevealOnScroll";
const certifications = [{
  icon: ShieldCheck,
  label: "Uluslararası Sağlık Turizmi Yetkisi"
}, {
  icon: Lock,
  label: "VIP Hasta Gizliliği ve Güvenliği"
}, {
  icon: FileCheck,
  label: "Modern Klinik Akreditasyonu"
}, {
  icon: CheckCircle,
  label: "%100 Hasta Memnuniyeti Garantisi"
}];
function ContactForm() {
  const {
    isSubmitting,
    isSubmitted,
    submitError,
    successMessage,
    handleSubmit,
    resetForm,
    control
  } = useWvcForm();
  if (isSubmitted && !submitError) {
    return <div data-section-id="18602" className="flex flex-col items-center justify-center h-full min-h-[400px] text-center p-8 animate-in fade-in zoom-in duration-500">
        <div className="w-16 h-16 bg-primary/20 rounded-full flex items-center justify-center mb-6 text-primary">
          <CheckCircle className="w-8 h-8" />
        </div>
        <h3 className="text-2xl font-serif font-bold mb-2 text-foreground">Randevunuz Alındı</h3>
        <p className="text-muted-foreground mb-8 max-w-md">{successMessage}</p>
        <Button onClick={resetForm} variant="outline" className="min-w-[200px] border-primary text-primary hover:bg-primary hover:text-white">
          Yeni Randevu Talebi
        </Button>
      </div>;
  }
  return <Form onSubmit={handleSubmit} className="space-y-8">
      <div className="grid md:grid-cols-2 gap-8">
        <FormField control={control} name="full_name" rules={{
        required: "Ad Soyad gereklidir"
      }} render={({
        field
      }) => <FormItem>
              <FormLabel className="text-foreground/70 font-sans text-sm uppercase tracking-wider">Adınız Soyadınız</FormLabel>
              <FormControl>
                <input {...field} placeholder="Örn. Ayşe Yılmaz" className="w-full bg-transparent border-b border-muted px-0 py-2 text-foreground placeholder:text-muted-foreground/40 focus:outline-none focus:border-primary transition-all duration-300 rounded-none" />
              </FormControl>
              <FormMessage />
            </FormItem>} />

        <FormField control={control} name="email" rules={{
        required: "E-posta gereklidir",
        pattern: {
          value: /^[^\s@]+@[^\s@]+\.[^\s@]+$/,
          message: "Geçersiz e-posta adresi"
        }
      }} render={({
        field
      }) => <FormItem>
              <FormLabel className="text-foreground/70 font-sans text-sm uppercase tracking-wider">E-posta Adresiniz</FormLabel>
              <FormControl>
                <input {...field} type="email" placeholder="ayse@example.com" className="w-full bg-transparent border-b border-muted px-0 py-2 text-foreground placeholder:text-muted-foreground/40 focus:outline-none focus:border-primary transition-all duration-300 rounded-none" />
              </FormControl>
              <FormMessage />
            </FormItem>} />
      </div>

      <div className="grid md:grid-cols-2 gap-8">
        <FormField control={control} name="phone" render={({
        field
      }) => <FormItem>
              <FormLabel className="text-foreground/70 font-sans text-sm uppercase tracking-wider">Telefon Numaranız</FormLabel>
              <FormControl>
                <input {...field} type="tel" placeholder="+90 5xx xxx xx xx" className="w-full bg-transparent border-b border-muted px-0 py-2 text-foreground placeholder:text-muted-foreground/40 focus:outline-none focus:border-primary transition-all duration-300 rounded-none" />
              </FormControl>
              <FormMessage />
            </FormItem>} />

        <FormField control={control} name="company" render={({
        field
      }) => <FormItem>
              <FormLabel className="text-foreground/70 font-sans text-sm uppercase tracking-wider">
                İlgilendiğiniz Tedavi
              </FormLabel>
              <FormControl>
                <input {...field} placeholder="Örn. Hollywood Smile" className="w-full bg-transparent border-b border-muted px-0 py-2 text-foreground placeholder:text-muted-foreground/40 focus:outline-none focus:border-primary transition-all duration-300 rounded-none" />
              </FormControl>
              <FormMessage />
            </FormItem>} />
      </div>

      <FormField control={control} name="message" rules={{
      required: "Mesaj alanı gereklidir"
    }} render={({
      field
    }) => <FormItem>
            <FormLabel className="text-foreground/70 font-sans text-sm uppercase tracking-wider">Notlarınız</FormLabel>
            <FormControl>
              <textarea {...field} rows={4} placeholder="Randevu için tercih ettiğiniz gün veya saati belirtebilirsiniz..." className="w-full bg-transparent border-b border-muted px-0 py-2 text-foreground placeholder:text-muted-foreground/40 focus:outline-none focus:border-primary transition-all duration-300 rounded-none resize-none" />
            </FormControl>
            <FormMessage />
          </FormItem>} />

      {submitError && <div className="p-4 bg-destructive/10 border border-destructive/20 text-destructive text-sm rounded-none">
          {submitError}
        </div>}

      <Button type="submit" disabled={isSubmitting} className="w-full h-14 text-base font-sans font-semibold tracking-widest uppercase bg-gradient-to-r from-primary to-primary/80 text-white shadow-lg hover:shadow-primary/20 transition-all duration-300 rounded-none">
        {isSubmitting ? <>
            <Loader2 className="mr-2 h-5 w-5 animate-spin" />
            İşleniyor...
          </> : "Randevu Talebi Oluştur"}
      </Button>
    </Form>;
}
export default function GetInTouch() {
  const {
    ref: sectionRef,
    isVisible
  } = useRevealOnScroll();
  return;
}